export default {
    checkinList: { items: [], _link: {}, _meta: {} },
    checkinListItems: [],
    staffList: { items: [], _link: {}, _meta: {} },
    staffData: [],
    promotionList: [
        { id: 1, value: '5', type: "percent", content: 'Remind after 30 days not visit', checked: undefined },
        { id: 2, value: '10', type: "usd", content: 'Remind after 30 days not visit', checked: undefined },
        { id: 3, value: '1', type: "percent", content: 'Remind after 30 days not visit', checked: undefined },
        { id: 4, value: '5', type: "usd", content: 'Remind after 30 days not visit', checked: undefined }
    ],
    checkoutInfo: null,
    checkoutHistory: { items: [], _link: {}, _meta: {} },
    checkoutHistoryItems: [],
    historySummary: {},
    checkoutData: {},
    checkinData: {},
    checkinInfo: {},
    lastCheckinRecord: {},
}
